import { render } from "./TencentAdv.vue?vue&type=template&id=761b3918&scoped=true"
import script from "./TencentAdv.vue?vue&type=script&lang=js"
export * from "./TencentAdv.vue?vue&type=script&lang=js"

import "./TencentAdv.vue?vue&type=style&index=0&id=761b3918&lang=less&scoped=true"

import exportComponent from "E:\\qq\\前端(1)\\前端\\后台vue\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761b3918"]])

export default __exports__